import { env } from './env';

export type AppMode = 'web' | 'kiosk';

/**
 * Mode resolution, in precedence order:
 *   1. ?mode=kiosk / ?mode=web  — how the kiosk shell will load us, and how we
 *      demo either flow from a laptop.
 *   2. VITE_MODE at build time  — a kiosk-only Netlify deploy context.
 *   3. web.
 */
export function resolveMode(search: string = window.location.search): AppMode {
  const param = new URLSearchParams(search).get('mode');
  if (param === 'kiosk' || param === 'web') return param;
  return env.defaultMode === 'kiosk' ? 'kiosk' : 'web';
}

/** ?admin=1 opens the show-night diagnostics view. Also reachable by key combo. */
export function adminRequested(search: string = window.location.search): boolean {
  return new URLSearchParams(search).get('admin') === '1';
}
